import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getTipoAplicacao } from "../../services/api_tipo_aplicacao";
import { getEmpresas } from "../../services/api_base";
import { getEmpresaById } from "../../services/api_cadastros_empresas";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getPessoas } from "../../services/api_pessoas";
import { getUnidadesById } from "../../services/api_cadastros_unidades";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const HistogramaForm = ({
  show,
  handleClose,
  handleGenerate,
  setFiltro,
  setShowForm,
  setShowRelatorio,
}) => {
  const [empresa, setEmpresa] = useState("");
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [unidade, setUnidade] = useState("");
  const [nomeUnidade, setNomeUnidade] = useState("");
  const [tipoAplicacao, setTipoAplicacao] = useState("");
  const [descricaoTipoAplicacao, setDescricaoTipoAplicacao] = useState("");
  const [descricaoAplicacao, setDescricaoAplicacao] = useState("");
  const [id_aplicacao, setAplicacao] = useState("");
  const [id_pessoa, setManutentor] = useState("");
  const [nomeManutentor, setNomeManutentor] = useState("");
  const [id_user_gerou, setSolicitante] = useState("");
  const [nomeSolicitante, setNomeSolicitante] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [unidadesListagem, setUnidadesListagem] = useState([]);
  const [tiposAplicacaoListagem, setTiposAplicacaoListagem] = useState([]);
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [aplicacoes, setAplicacoes] = useState([]);
  const [manutentoresListagem, setManutentores] = useState([]);
  const [solicitantesListagem, setSolicitanteListagem] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showMessage, setShowMessage] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = () => {
      Swal.fire({
        title: "Carregando dados...",
        didOpen: async () => {
          Swal.showLoading();
          try {
            const response = await getEmpresas();
            if (response && response.status === 200) {
              const empresasAtivas = response.data.empresas.filter(
                (empresa) => empresa.deleted_at == null
              );
              setEmpresasListagem(empresasAtivas);
              Swal.close();
            } else {
              return Swal.fire({
                icon: "error",
                title: "Erro interno",
                text: "Não foi possível carregar os dados necessários para gerar relatórios. Tente novamente mais tarde.",
                confirmButtonText: "Tentar novamente",
                preConfirm: fetchEmpresas,
              });
            }
            //console.log(response);
          } catch (error) {
            console.error("Erro ao obter empresas:", error);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    };

    fetchEmpresas();
  }, []);

  useEffect(() => {
    const fetchManutentores = async () => {
      try {
        const response = await getPessoas();

        if (response && response.status === 200) {
          const manutentoresAtivos = response.data.pessoas.filter(
            (pessoa) =>
              pessoa.deleted_at == null && pessoa.tipo.toString() === "3"
          );
          setManutentores(manutentoresAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter manutentores:", error);
      }
    };

    fetchManutentores();
  }, []);

  useEffect(() => {
    const fetchSolicitantes = async () => {
      try {
        const response = await getPessoas();
        if (response && response.status === 200) {
          const solicitantesAtivos = response.data.pessoas.filter(
            (pessoa) => pessoa.deleted_at == null
          );
          setSolicitanteListagem(solicitantesAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado ao buscar as ordens de serviço.");
        }
      } catch (error) {
        console.error("Erro ao obter solicitantes:", error);
      }
    };

    if (unidade) {
      fetchSolicitantes();
    }
  }, [unidade]);

  useEffect(() => {
    const fetchTipoAplicacao = async () => {
      try {
        const response = await getTipoAplicacao();
        if (response && response.status === 200) {
          const tiposAplicacaoAtivos = response.data.TiposAplicacao.filter(
            (tipoAplicacao) => tipoAplicacao.deleted_at == null
          );
          setTiposAplicacaoListagem(tiposAplicacaoAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter tipos de aplicação:", error);
      }
    };

    fetchTipoAplicacao();
  }, []);

  const handleGenerateRelatorio = () => {
    if (!empresa) {
      return Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "É necessário informar a empresa.",
      });
    }

    // Verificar se o intervalo de data é maior que um ano
    const startDate = new Date(dataInicial);
    const endDate = new Date(dataFinal);
    const oneYearInMs = 365 * 24 * 60 * 60 * 1000;

    if (endDate - startDate > oneYearInMs) {
      return Swal.fire({
        icon: "error",
        title: "Intervalo de data inválido",
        text: "O intervalo de data não pode ser maior que um ano.",
      });
    }

    try {
      handleGenerate({
        empresa,
        unidade,
        tipoAplicacao,
        id_pessoa,
        nomeEmpresa,
        nomeUnidade,
        descricaoTipoAplicacao,
        descricaoAplicacao,
        nomeManutentor,
        nomeSolicitante,
        id_user_gerou,
        id_aplicacao,
        dataInicial,
        dataFinal,
      });
      handleClose();
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };

  const handleUnidadesEmpresa = async (idEmpresa) => {
    if(!idEmpresa) {
      setUnidadesListagem([])
      setShowMessage(false)
      return;
    }
    Swal.fire({
      title: "Carregando unidades da empresa",
      didOpen: async () => {
        Swal.showLoading();
        try {
          const response = await getEmpresaById(idEmpresa);
          if (response && response.status === 200) {
            const unidadesAtivas = response.data.empresa.unidades.filter(
              (unidade) => unidade.deleted_at == null
            );
            setUnidadesListagem(unidadesAtivas);
            Swal.close();
          }
        } catch (error) {
          console.error(error);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const handleUnidadesAplicacao = async (idUnidade) => {
    if(!idUnidade) {
      setAplicacoes([])
      setShowMessage(false)
      return;
    }
    Swal.fire({
      title: "Carregando as aplicações da unidade",
      didOpen: async () => {
        Swal.showLoading();
        try {
          const response = await getUnidadesById(idUnidade);
          if (response && response.status === 200) {
            const aplicacaoAtivas = response.data.unidade.aplicacoes.filter(
              (aplicacao) => aplicacao.deleted_at == null
            );
            setAplicacoes(aplicacaoAtivas);
            Swal.close();
          }
        } catch (error) {
          console.error("Erro ao obter aplicacoes:", error);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };


  const handleClearClick = () => {
    setEmpresa("");
    setUnidade("");
    setTipoAplicacao("");
    setManutentores("");
    setAplicacao("");
    setNomeEmpresa("");       
    setNomeUnidade("");        
    setNomeSolicitante("");   
    setNomeManutentor("");    
    setSolicitante("");       
    setDescricaoTipoAplicacao(""); 
    setDescricaoAplicacao(""); 
    setDataFinal("");
    setDataInicial("");
  };

  const handleGoHome = () => {
    navigate("/home");
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton onHide={handleGoHome}>
        <Modal.Title>Gerar Relatório</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formUnidade">
            <Form.Label>Empresa</Form.Label>
            <Form.Control
              as="select"
              value={empresa}
              onChange={(e) => {
                setEmpresa(e.target.value);
                handleUnidadesEmpresa(e.target.value);
                setNomeEmpresa(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );
                setShowMessage(true);
                //console.log(nomeEmpresa);
              }}
              required
            >
              <option value="">Selecione</option>
              {empresasListagem &&
                empresasListagem.map((empresa) => (
                  <option
                    key={empresa.id}
                    value={empresa.id}
                    data-nome={empresa.nome}
                  >
                    {empresa.nome}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formUnidade">
            <Form.Label>Unidade</Form.Label>
            <Form.Control
              as="select"
              value={unidade}
              disabled={!empresa}
              onChange={(e) => {
                setUnidade(e.target.value);
                handleUnidadesAplicacao(e.target.value);
                setNomeUnidade(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );
                setShowMessage(false)
                //console.log(nomeUnidade);
              }}
            >
              <option value="">Selecione</option>
              {unidadesListagem &&
                unidadesListagem.map((unidade, index) => (
                  <option
                    key={index}
                    value={unidade.id}
                    data-nome={unidade.nome}
                  >
                    {unidade.nome}
                  </option>
                ))}
            </Form.Control>
            {showMessage && !empresa && (
            <small className="form-text text-danger">
              Escolha uma unidade
            </small>
          )}
          </Form.Group>
          <Form.Group controlId="formTipoAplicacao">
            <Form.Label>Tipo de Aplicação</Form.Label>
            <Form.Control
              as="select"
              value={tipoAplicacao}
              onChange={(e) => {
                setTipoAplicacao(e.target.value);
                setDescricaoTipoAplicacao(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-descricao"
                  )
                );
              }}
              required
            >
              <option value="">Selecione</option>
              {tiposAplicacaoListagem &&
                tiposAplicacaoListagem.map((tipoAplicacao, index) => (
                  <option
                    key={index}
                    value={tipoAplicacao.id}
                    data-descricao={tipoAplicacao.descricao}
                  >
                    {tipoAplicacao.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formAplicacao">
            <Form.Label>Aplicação</Form.Label>
            <Form.Control
              as="select"
              value={id_aplicacao}
              disabled={!unidade}
              onChange={(e) => {
                setAplicacao(e.target.value);
                setDescricaoAplicacao(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );
                //console.log(descricaoAplicacao);
              }}
            >
              <option value="">Selecione</option>
              {aplicacoes &&
                aplicacoes.map((aplicacao, index) => (
                  <option
                    key={index}
                    value={aplicacao.id}
                    data-nome={aplicacao.descricao}
                  >
                    {aplicacao.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formSolicitantes">
            <Form.Label>Solicitantes</Form.Label>
            <Form.Control
              as="select"
              value={id_user_gerou.id}
              disabled={!unidade}
              onChange={(e) => {
                const selectedSolicitante =
                  e.target.options[e.target.selectedIndex];
                setSolicitante(e.target.value);
                setNomeSolicitante(selectedSolicitante.getAttribute("nome"));
              }}
              required
            >
              <option value="">Selecione</option>
              {solicitantesListagem &&
                solicitantesListagem.map((solicitante) => (
                  <option
                    key={solicitante.id}
                    value={solicitante.id}
                    nome={solicitante.nome}
                  >
                    {solicitante.nome}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formManutentores">
            <Form.Label>Manutentores</Form.Label>
            <Form.Control
              as="select"
              value={id_pessoa}
              onChange={(e) => {
                const selectedManutentor =
                  e.target.options[e.target.selectedIndex];
                setManutentor(e.target.value);
                setNomeManutentor(selectedManutentor.getAttribute("nome"));
              }}
            >
              <option value="">Selecione</option>
              {manutentoresListagem &&
                manutentoresListagem.map((manutentor) => (
                  <option
                    key={manutentor.id}
                    value={manutentor.id}
                    nome={manutentor.nome}
                  >
                    {manutentor.nome}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formDataInicio">
            <Form.Label>Data de Início</Form.Label>
            <Form.Control
              type="date"
              value={dataInicial}
              onChange={(e) => {
                setDataInicial(e.target.value);
                setShowMessage(false);
              }}
            />
          </Form.Group>
          {showMessage && !unidade && (
            <small className="form-text text-danger">
              Escolha uma data de início
            </small>
          )}
          <Form.Group controlId="formDataFim">
            <Form.Label>Data de Fim</Form.Label>
            <Form.Control
              type="date"
              value={dataFinal}
              onChange={(e) => {
                setDataFinal(e.target.value);
                setShowMessage(false);
              }}
            />
          </Form.Group>
          {showMessage && !dataInicial && (
            <small className="form-text text-danger">
              Escolha uma data de fim
            </small>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Link to={`/home`}>
          <button className="btn btn-light text-dark">
            <FontAwesomeIcon icon={faHome} size="1x" color= 'gray' />
          </button>
        </Link>
        <Button
          variant={!empresa || !dataInicial || !dataFinal ? "secondary" : "primary"}
          onClick={handleGenerateRelatorio}
          disabled={!empresa || !dataInicial || !dataFinal}
        >
          Gerar
        </Button>
        <Button variant="danger" onClick={handleClearClick}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HistogramaForm;
